import React, { useState } from 'react';
import {
  Text,
  View,
  StyleSheet,
  Pressable,
  Platform,
  Linking,
} from 'react-native';

import WhatsAppIcon from '../../../assets/Icons/Whatsapp';
import PhoneIcon from '../../../assets/Icons/PhoneIcon';
import gs from '../../styles/globalStyles';
import classes from '../../styles/globalClasses';
import BottomSheetContainer from '../Bottomsheet/Bottomsheet';
import { CaretRight, X } from '../Icons';
import EmailIcon from '../../../assets/Icons/Email';
import Typography from '../typography/Typography';
import { ColorTokens, FontFamilyTokens, FontSizeTokens, TypographyTypeDLS } from '@voltmoney/schema';
import { ThemedText, ThemedView } from '../../theme';
import {ThemedTouchableOpacity}  from '../../theme/Components';
import { useAppSelector } from '../../store/hooks';
import { useDarkMode } from '@app/utils';
import ContactUs from '@app/screens/UserProfile/ContactUs';




const NeedHelp = ({callDataVisible=false}) => {
  const { emailData,waData,showCall,callData ,platform} = useAppSelector((state) => state.platformParams);
  const [isBottomSheetVisible, setIsBottomSheetVisible] = useState(false);
  const isDarkMode = useDarkMode()

  const closeBottomSheet = () => {
    setIsBottomSheetVisible(false);
  };

  return (
    <>
      <ThemedTouchableOpacity
        eventName='NEED_HELP_HEADER'
        onPress={() => setIsBottomSheetVisible(true)}
        style={[
          gs.flexRow,
          gs.setBg(isDarkMode?'#48536b': '#F3F5FC'),
          gs.setBorderRadius(24),
          gs.setPaddingHorizontal(8),
          gs.setPaddingVertical(4),
          gs.alignItemsCenter,
        ]}>
        <WhatsAppIcon />
        <ThemedText variant='b5r' color='text-action-primary'>
          NEED HELP?
        </ThemedText>
        {/* <Typography
            label={'NEED HELP?'}
            fontSize={FontSizeTokens.XXS}
            fontWeight={"600"}
            lineHeight={16}
            color={isDarkMode? ColorTokens.White :  ColorTokens.Primary_100}
            fontFamily={FontFamilyTokens.Inter}
        /> */}
      </ThemedTouchableOpacity>
      <BottomSheetContainer
        isVisible={isBottomSheetVisible}
        close={closeBottomSheet}
        closeOnBackdropPress={true}
        borderTopRightRadius={10}
        borderTopLeftRadius={10}
        containerStyle={gs.setBg('#fefefe')}>
        <ContactUs/>
      </BottomSheetContainer>
    </>
  );
};

const ls = StyleSheet.create({
  container: {
    borderColor: '#d0d6f5',
    backgroundColor: '#fafbfe',
    borderRadius: 12,
    borderWidth: 1,
    marginTop: 16,
    padding: 16,
  },
});

export default NeedHelp;
